import React, {useEffect, useState} from "react";
import {getTrainingsPopular,getTrainingsVisible} from "../../service";
import {TrainingsData} from "../types";
import TrainingsList from "../../components/trainings";
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";


const OfflineTrainings: React.FC<{ type?: 'home' | 'detail' }> = ({type = 'detail'}) => {

    const [lists, setLists] = useState<Array<TrainingsData>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination()

    useEffect(() => {
        if (type === 'detail') {
            getTrainingsVisible({
                pageNum,
                status:0
            }).then(res => {
                if(res.code === 1){
                    const lists = res.data.list
                    if((lists as Array<TrainingsData>).length > 0){
                        setLists(list => list.concat(lists))
                    }else{
                        noMore()
                    }
                }
            })
        } else {
            getTrainingsPopular()
                .then(res => {
                    if (res.code === 1) {
                        setLists(res.data)
                    }
                })
        }

    }, [type,pageNum])

    return <div>
        <TrainingsList type={type} lists={lists}/>
        {
            type === 'detail' && <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
        }
    </div>
}

export default OfflineTrainings
